// import router from "../../../router";
const state = {
   userDetails: null,
   paymentInfo: null,
   deliveryInfo: null
}

// getters
const getters = {
   userDetails: state => {
      return state.userDetails;
   },
   paymentInfo: state => {
      return state.paymentInfo;
   }
}

// actions
const actions = {
   addUserDetails(context, payload) {
      context.commit('onAddedUserDetails', payload);
   },
   addPaymentInfo(context, payload) {
      context.commit('addPaymentInfo', payload);
   },
   addDeliveryInfo(context, payload) {
      context.commit('addDeliveryInfo', payload);
   },
   destroyPaymentInfo(context) {
      context.commit('destroyPaymentInfo');

   }
}

// mutations
const mutations = {
   /**
    * This function sets the value for the panel (open up the promo code expansion panel)
   **/
   onAddedUserDetails(state, payload) {
      state.userDetails = payload;
   },
   addDeliveryInfo(state, payload) {
      state.deliveryInfo = payload;
   },
   /**
    * This function sets the value for the panel (open up the payment option expansion panel)
   **/
   addPaymentInfo(state, payload) {
      state.paymentInfo = payload;
      // router.push('/checkout/final-receipt');
   },
   destroyPaymentInfo(state) {
      state.userDetails = null;
      state.paymentInfo = null;
   }
}

export default {
   state,
   getters,
   actions,
   mutations,
}